import React, { useContext, useState, useEffect } from "react";
import { AppContext, DispatchContext } from "../AppContext";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogTitle from '@material-ui/core/DialogTitle';
import * as actions from '../actions/actions';
import Button from '@material-ui/core/Button';
import { makeStyles } from "@material-ui/styles";
import DialogContent from '@material-ui/core/DialogContent';
import { Checkbox, TextField, FormControlLabel, Switch, MenuItem } from "@material-ui/core";
import { config, resolveNotificationMessage } from '../helpers/constants';
import Service from "../services/service";
import LoadingScreen from "./LoadingScreen";

const useStyles = makeStyles((theme) => ({
    dialogContent: {
        width: 500,
        overflow: 'hidden'
    },
    textField: {
        width: "100%",
        marginBottom: theme.spacing(1)
    }
}));

export default function DownloadReportDialog(props) {
    const state = useContext(AppContext);
    const s = state.strings;
    const classes = useStyles(state);
    const dispatch = useContext(DispatchContext);
    const [settings, setSettings] = useState({});
    const [loading, setLoading] = useState(false);


    // update local settings from state when dialog becomes visible
    useEffect(() => {
        state.ui.downloadReportDialogOpen && setSettings(state.user.settings);
    }, [state.ui.downloadReportDialogOpen])

    const submitButton = () => {
        setLoading(true);
        Service.createPdfReport({ ...settings, permalinkid: state.downloadReportIds[0] }).then(res => {
            setLoading(false);
            if (res.success) {
                closeDialogBox();
                let url = config.backendUrl + "reportpreview/?id=" + state.downloadReportIds[0] + "&" + settings.reportFormat + "=1";
                if (settings.reportFormat == "cst") {
                    url += "&pdf=1";
                }
                var link = document.createElement("a");
                link.style.display = 'none';
                link.href = url;
                link.click();
                link.remove();
            } else {
                dispatch(actions.openToast({ type: "error", message: resolveNotificationMessage(res.errors[0], s.notificationMessage), status: true }));
            }
        });

    }

    const handleChange = (newValue, key) => {
        if ((key == "reportFormat") && (newValue == "pdf")) {
            setSettings({ ...settings, [key]: newValue, reportRenderComments: false });
        } else if ((key == "reportFormat") && (newValue == "cst")) {
            setSettings({ ...settings, [key]: newValue, reportRenderComments: false, reportIncludeGuide: false });
        } else {
            setSettings({ ...settings, [key]: newValue });
        }
    }


    const closeDialogBox = () => {
        dispatch(actions.setUI({ downloadReportDialogOpen: false }));
        if (settings.saveAsDefault) {
            dispatch(actions.setUserSettings({ ...settings, saveAsDefault: false }));
            Service.updateUserSettings(settings).then(res => {
                if (!res.success) {
                    dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
                }
            });
        }
    }

    return (
        <form noValidate autoComplete="off" style={{ width: "100%" }}>
            <Dialog maxWidth='sm' disableBackdropClick={false} aria-labelledby="customized-dialog-title" open={state.ui.downloadReportDialogOpen}>
                <LoadingScreen status={loading} opacity={0.75} text={s.downloadReportDialog.creatingReport} hint={s.downloadReportDialog.creatingHint} />
                <DialogTitle>
                    {s.downloadReportDialog.title}
                </DialogTitle>
                <DialogContent dividers className={classes.dialogContent}>
                    <TextField className={classes.textField} select size="small" required label="Report Format"
                        value={settings.reportFormat}
                        onChange={(e) => handleChange(e.target.value, "reportFormat")}
                    >
                        <MenuItem key={'docx'} value={'docx'}>{s.downloadReportDialog.formatWord}</MenuItem>
                        <MenuItem key={'pdf'} value={'pdf'}>{s.downloadReportDialog.formatPdf}</MenuItem>
                        <MenuItem key={'cst'} value={'cst'}>{s.downloadReportDialog.formatCustom}</MenuItem>
                    </TextField>
                    <TextField className={classes.textField} select size="small" required label={s.downloadReportDialog.language}
                        value={settings.reportLang}
                        onChange={(e) => handleChange(e.target.value, "reportLang")}
                    >
                        <MenuItem key={'en'} value={'en'}>{s.languages.en}</MenuItem>
                        <MenuItem key={'de'} value={'de'}>{s.languages.de}</MenuItem>
                    </TextField>
                    <FormControlLabel className={classes.textField}
                        control={<Switch checked={settings.reportRenderComments} onChange={(e) => handleChange(e.target.checked, "reportRenderComments")} disabled={settings.reportFormat != "docx"} />}
                        label={s.downloadReportDialog.renderTitle}
                    />
                    <FormControlLabel className={classes.textField}
                        control={<Switch checked={settings.reportIncludeGuide} onChange={(e) => handleChange(e.target.checked, "reportIncludeGuide")} disabled={settings.reportFormat == "cst"} />}
                        label={s.downloadReportDialog.renderGuide}
                    />
                    <FormControlLabel className={classes.textField}
                        control={<Switch checked={settings.reportTruncate} onChange={(e) => handleChange(e.target.checked, "reportTruncate")} />}
                        label={s.downloadReportDialog.truncateText}
                    />
                    {state.user.loggedIn &&
                        <FormControlLabel
                            control={<Checkbox checked={settings.saveAsDefault} onChange={(e) => handleChange(e.target.checked, "saveAsDefault")} name="checkedA" />}
                            label={s.downloadReportDialog.saveDefault}
                        />
                    }
                </DialogContent>
                <DialogActions className={classes.popupButton} >
                    <Button variant="contained" color="primary" onClick={submitButton}>
                        {s.downloadReportDialog.createReport}
                    </Button>
                    <Button variant="contained" color="primary" onClick={closeDialogBox}>
                        {s.cancel}
                    </Button>
                </DialogActions>
            </Dialog>
        </form>
    )
}